/** 공지사항 목록 — 전체 대상 + 내 소속 공지. 담당자용과 같은 API(기사 클레임이면 소속으로 제한). */

import { useNavigate } from 'react-router-dom';
import { useDriverList } from '../lib/driverCache';
import Screen, { Empty, ErrorBanner, Loading } from './Screen';
import { when } from './format';

export default function Notices() {
  const navigate = useNavigate();
  // 홈에서 미리 받아 둔 목록을 바로 그리고 뒤에서 새로 받는다(lib/driverCache.ts).
  const { data, error } = useDriverList('notices', '공지를 불러오지 못했습니다.');
  const rows = data?.rows ?? null;

  return (
    <Screen title="공지사항">
      {error && <ErrorBanner>{error}</ErrorBanner>}
      {rows === null ? (
        <Loading />
      ) : rows.length === 0 ? (
        <Empty>공지가 없습니다.</Empty>
      ) : (
        <ul className="space-y-3">
          {rows.map((n) => (
            <li key={n.notice_id}>
              <button
                className="driver-row flex min-h-touch w-full items-center gap-3 px-4 py-3 text-left"
                onClick={() => navigate(`/notices/${n.notice_id}`)}
              >
                {n.is_top ? <span aria-hidden>📌</span> : null}
                <span className="flex-1">
                  <span className="block text-lg font-semibold text-ink">
                    {n.subject || '(제목 없음)'}
                    {n.is_new ? <span className="ml-2 text-sm font-bold text-brand-600">NEW</span> : null}
                  </span>
                  <span className="mt-0.5 block text-sm text-ink-faint">{when(n.created_at)}</span>
                </span>
                {!n.is_read ? <span className="h-2.5 w-2.5 shrink-0 rounded-full bg-brand-500" aria-label="안 읽음" /> : null}
              </button>
            </li>
          ))}
        </ul>
      )}
    </Screen>
  );
}
